import RoutePathString from '@components/pages/RoutePathString';
import { getLocalizationById } from '@context/useMyRouting/helpers';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { getCargo } from '@pages/Basket/components/ServicesList/components/OrderList/components/OrderListItem/helpers';
import { ProductSummaryProps, RouteResult } from '@services/requests/orderService/types';
import { BranchItem } from '@services/requests/routeCalculator/locationsBranchSearchService/interfaces';
import React from 'react';
import { useTranslation } from 'react-i18next';

// Компонент вывода сводной информации по маршруту
const RouteSummary = (props: ProductSummaryProps) => {
  const {
    product: { data },
    langId,
  } = props;
  const langCode = getLocalizationById(langId).countryCode;
  const { t } = useTranslation(['OrderList', 'Common', 'RoutesListComponent']);

  // Получаем данные маршрута
  const route: RouteResult = JSON.parse(data);

  const {
    baseData: { containers, units, trucks },
    terminals,
    routePointsItems: { from, to },
  } = route;

  // Получаем описание типа груза
  const cargo = getCargo(
    route.type,
    { containers, units, trucks },
    {
      containers: route.cargoParameters.containerParameters,
      customs: route.cargoParameters.customCargoParameters,
      trucks: route.cargoParameters.truckParameters,
    },
    langCode,
    langId
  );

  let points: BranchItem[] = [
    ...(route.route.routes[0].steps
      .map((s) => terminals.find((term) => term.id === s.startTerminal?.id))
      .filter((s) => !!s) as BranchItem[]),
    to,
  ];

  // Массив 'terminals' может не содержать начального терминала
  if (points[0].id !== from.id && from.type === 'terminal') {
    points = [from, ...points];
  }

  // если отправка идет не из терминала
  if (from.type !== 'terminal') {
    points.unshift(from);
  }

  return (
    <div className={'order-product-component'}>
      <Typography variant={'h4'}>
        <RoutePathString value={points} />
        <span>
          {', '} {route.route.deliveryTime}{' '}
          {route.route.deliveryTime <= 1 ? t('Common:Day') : t('Common:Days')}
        </span>
      </Typography>
      {route.isNotCompleteResult && (
        <div className="route-marks">
          <Tooltip title={t('RoutesListComponent:isRouteNotComplete')} placement="top">
            <div className="route-is-not-full">
              <ErrorOutlineIcon fontSize={'small'} />
              <div>{t('RoutesListComponent:isRouteNotCompleteName')}</div>
            </div>
          </Tooltip>
        </div>
      )}
      <div className="cargo">
        <div className="cargo--title">{t('RoutesListComponent:cargoList')}:</div>
        {cargo.map((cargo, i) => (
          <div key={i} className="cargo--item">
            - {cargo}
          </div>
        ))}
      </div>
    </div>
  );
};

// Экспортируем компонент
export default RouteSummary;
